<template>
  <modal
    :show.sync="showNewPassengerModal"
    bodyClasses="pt-0"
    size="lg"
    @close="
      () => {
        closeModal();
        clearData();
      }
    "
    no-close-on-backdrop
  >
    <template slot="header" class="pb-0">
      <h6 class="subtitle" id="modal-title-default">
        Add PAX
      </h6>
    </template>

    <div class="row forms mt-4">
      <div class="col-xl-5 col-lg-5 col-md-9 col-sm-8 col-12">
        <WSelect
          label="PAX"
          filterable
          :loading="loading"
          placeholder="Enter Name Passenger"
          v-model="passengerId"
          @change="selectPassenger"
          id="passenger"
          name="passenger"
          no-data-text="Search by PAX"
          clearable
          remote
        >
          <el-option
            v-for="(passenger, index) in passengers"
            :value="passenger._id"
            :label="passenger.full_name"
            :disabled="isIncluded(passenger, passengersIncluded)"
            :key="index"
          >
          </el-option>
        </WSelect>
      </div>
    </div>

    <div class="row forms">
      <div class="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-6 form-group">
        <label for="title" class="title-label"
          ><span class="markrequired">*</span>Type</label
        >

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            v-model="passenger.type"
            :aria-describedby="ariaDescribedby"
            id="type"
            name="type"
            buttons
            button-variant="outline-neutral"
            size="md"
          >
            <b-form-radio value="SENIOR" class="pc-5" tabindex="3"
              >Senior</b-form-radio
            >
            <b-form-radio value="ADULT" class="pc-5">Adult</b-form-radio>
            <b-form-radio value="CHILD" class="pc-5">Child</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-6 form-group">
        <label for="title" class="title-label"
          ><span class="markrequired">*</span>Title</label
        >

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            v-model="passenger.gender"
            :aria-describedby="ariaDescribedby"
            id="radio-gender"
            name="radio-gender"
            buttons
            button-variant="outline-neutral"
            size="md"
          >
            <b-form-radio value="male" class="pc-5" tabindex="3"
              >Mr.</b-form-radio
            >
            <b-form-radio value="female" class="pc-5">Mrs.</b-form-radio>
            <b-form-radio value="other" class="pc-5">Mx.</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <base-input
          v-model.trim="$v.passenger.first_name.$model"
          inputClasses="text-capitalize"
          label="First Name"
          placeholder="First Name"
          id="ncfirst_name_passenger"
          name="ncfirst_name_passenger"
          tab-index="15"
          format="capitalize"
          minlength="2"
          maxlength="45"
          markrequired
          :error="
            $v.passenger.first_name.$error
              ? `Must be between ${$v.passenger.first_name.$params.minLength.min} and ${$v.passenger.first_name.$params.maxLength.max} characters.`
              : ''
          "
        />
      </div>

      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <base-input
          v-model.trim="$v.passenger.last_name.$model"
          label="Last Name"
          inputClasses="text-capitalize"
          placeholder="Last Name"
          id="nclast_name_passenger"
          name="nclast_name_passenger"
          tab-index="16"
          format="capitalize"
          minlength="2"
          maxlength="45"
          markrequired
          :error="
            $v.passenger.last_name.$error
              ? `Must be between ${$v.passenger.last_name.$params.minLength.min} and ${$v.passenger.last_name.$params.maxLength.max} characters.`
              : ''
          "
        />
      </div>

      <div
        class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 inputphone form-group"
        v-bind:class="{ 'is-invalid': $v.passenger.phone.$error }"
        @paste.capture="handlePhonePaste"
      >
        <label class="title-label">Contact Number</label>
        <vue-tel-input
          v-model="contactNumber"
          key="NumberPhonepassenger"
          inputId="NumberPhonepassenger"
          name="NumberPhonepassenger"
          required
          mode="international"
          inputClasses="input no-label no-err"
          :dynamicPlaceholder="true"
          :disabledFetchingCountry="true"
          :validCharactersOnly="true"
          :wrapperClasses="[
            $v.passenger.phone.$error ? 'is-invalid' : '',
            'mb-0'
          ]"
          @input="validateContactNumber"
        ></vue-tel-input>
        <small class="invalid-feedback mt-1" v-if="$v.passenger.phone.$error">
          {{ getPhoneNumberValidationErrorMessage($v.passenger.phone) }}
        </small>
      </div>

      <div class="col-xl-6 col-lg-5 col-md-6 col-sm-12 col-12">
        <base-input
          id="passenger_email"
          name="passenger_email"
          v-model.trim="$v.passenger.email.$model"
          label="Email Address"
          placeholder="Email Address"
          format="lowercase"
          :error="getEmailValidationErrorMessage($v.passenger.email)"
          autocomplete="off"
        />
      </div>

      <div
        class="col-xl-3 col-lg-3 col-md-5 col-sm-4 col-12"
        v-if="
          ['arrival', 'departure', 'station', 'port'].includes(transferType)
        "
      >
        <base-input
          :label="getLabelTransferType(transferType)"
          v-model="flightNumber"
          id="flightNumber"
          name="flightNumber"
          format="uppercase"
        />
      </div>
      <div class="col-xl-3 col-lg-3 col-md-5 col-sm-4 col-12">
        <label for="driver_notifications" class="title-label ml-0">
          Send Notification
          <el-popover placement="top" trigger="hover" width="300" class="curp">
            <span>
              Enable this option to send a notification to the passenger when
              the reservation is saved.
            </span>
            <div class="badge badge-primary" slot="reference">
              ?
            </div>
          </el-popover>
        </label>
        <base-switch
          v-model="sendNotification"
          class="mt-2"
          @input="setSendNotification"
        ></base-switch>
      </div>
    </div>

    <div class="modal-footer col-12">
      <base-button
        type="primary"
        class="min-button mb-0"
        @click="savePassenger('close')"
        :disabled="loadingRequest"
      >
        <i class="flaticon-floppy-disk"></i> Add & Close
      </base-button>

      <base-button
        type="primary"
        class="min-button mb-0 ml-auto"
        @click="savePassenger('new')"
        :disabled="loadingRequest"
      >
        <i class="flaticon-floppy-disk"></i> Add & New
      </base-button>
    </div>
  </modal>
</template>

<script>
import lodash from "lodash";
import { mapGetters } from "vuex";
import WSelect from "@/components/Select";
import { VueTelInput } from "vue-tel-input";
import { PassengersAPI } from "../../core/api";
import {
  required,
  minLength,
  maxLength,
  email,
  helpers,
  requiredIf
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚŽž'-\s]*$/);
import { v4 as uuidv4 } from "uuid";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "NewPassenger",
  components: {
    VueTelInput,
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    partner: {
      type: Object,
      default: () => {
        return {
          id: null,
          type: ""
        };
      },
      description: "(Owner identifier)"
    },
    passengers: {
      type: Array,
      default: () => [],
      description: "(passengers by customers)"
    },
    passengersIncluded: {
      type: Array,
      default: () => [],
      description: "(Passengers included)"
    },
    maxPassengers: {
      type: Number,
      default: 0,
      description: "Maximum number of passengers"
    },
    transferType: {
      type: String,
      required: true,
      description:
        "(arrival, departure, station, port, hourly, journey) Transfer Type"
    }
  },
  data() {
    return {
      passenger: {
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        phone: "",
        gender: "male",
        address: {
          country: "",
          city: "",
          state: "",
          zip_code: "",
          street: ""
        },
        notes: "",
        relationship: {
          owner: "",
          type: "travel_agency"
        },
        another_contact: {
          identifier: "",
          type: ""
        },
        type: "ADULT"
      },
      loading: false,
      contactNumber: "",
      flightNumber: "",
      showNewPassengerModal: false,
      passengerId: "",
      sendNotification: false,
      loadingRequest: false
    };
  },
  async created() {
    this.$v.passenger.email.$model = "";
    this.$v.passenger.phone.$model = "";
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showNewPassengerModal = current;
      },
      deep: true
    },
    partner: {
      handler: function(current, old) {
        if (current) {
          this.passenger.relationship.owner = current.id;
          this.passenger.relationship.type = current.type;
        }
      },
      deep: true
    }
  },
  methods: {
    async savePassenger(acction = "close") {
      if (this.totalPassengers < this.maxPassengers) {
        if (!this.$v.passenger.$invalid) {
          let passenger = lodash.cloneDeep(this.passenger);
          passenger.full_name = `${passenger.first_name} ${passenger.last_name}`;
          passenger.relationship.owner = this.partner.id;
          passenger.relationship.type = this.partner.type;
          if (this.passengerId) {
            this.loadingRequest = true;
            await this.addPassenger(passenger, acction);
            this.loadingRequest = false;
          } else {
            let reagisterPassenger = this.getRegisterStatus(
              passenger,
              this.passengerId
            );
            if (reagisterPassenger) {
              this.loadingRequest = true;
              await this.createPassenger(passenger, acction);
              this.loadingRequest = false;
            } else {
              this.loadingRequest = true;
              await this.addPassenger(passenger, acction);
              this.loadingRequest = false;
            }
          }
        } else {
          this.$v.passenger.$touch();
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "We are sorry, but you have exceeded the maximum number of allowed passengers. Please adjust the number of passengers to proceed.",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createPassenger(passenger, acction) {
      try {
        let { data } = await PassengersAPI.createPassenger(
          passenger,
          this.sesion.token
        );
        if (data.status) {
          let tempPassenger = data.data.passenger;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Passenger has been Saved",
            icon: "flaticon-check-3"
          });
          if (acction === "close") {
            this.closeModal();
          }
          this.$emit(
            "addPassenger",
            this.populatePassenger(
              tempPassenger,
              this.flightNumber,
              this.sendNotification
            )
          );
          this.clearData();
          return;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error saving the Passenger, please try again",
            icon: "flaticon-remove"
          });
          return;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Passenger, please try again",
          icon: "flaticon-remove"
        });
        return;
      }
    },
    async addPassenger(passenger, acction) {
      if (passenger) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Passenger has been Saved",
          icon: "flaticon-check-3"
        });
        if (acction === "close") {
          this.closeModal();
        }
        this.$emit(
          "addPassenger",
          this.populatePassenger(
            passenger,
            this.flightNumber,
            this.sendNotification
          )
        );
        this.clearData();
        return;
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Passenger, please try again",
          icon: "flaticon-remove"
        });
        return;
      }
    },
    handlePhonePaste(e) {
      e.preventDefault();
      const raw = (e.clipboardData || window.clipboardData).getData("text");
      this.contactNumber = raw
        .replace(
          /[\u0000-\u001F\u007F-\u009F\u00A0\u00AD\u180E\u200B-\u200F\u202A-\u202E\u2028\u2029\u202F\u205F\u2060\u2066-\u2069\uFEFF]/g,
          ""
        )
        .trim();
      this.$nextTick(() => {
        const input = document.getElementById("NumberPhonepassenger");
        if (input) input.dispatchEvent(new Event("input", { bubbles: true }));
      });
    },
    validateContactNumber(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.passenger.phone = result.number.e164;
        this.$v.passenger.phone.$model = this.passenger.phone;
      } else {
        this.passenger.phone = value;
        this.$v.passenger.phone.$model = value;
      }
    },
    async verifyPassengerEmail(email, customerId) {
      try {
        if (email) {
          let { data } = await PassengersAPI.checkPassengers(
            {
              email: email.toLowerCase(),
              "relationship.owner": customerId
            },
            this.sesion.token
          );
          if (data.status) {
            return !data.data.exists;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async verifyPassengerPhone(phone, customerId) {
      try {
        if (email) {
          let { data } = await PassengersAPI.checkPassengers(
            {
              phone: phone,
              "relationship.owner": customerId
            },
            this.sesion.token
          );
          if (data.status) {
            return !data.data.exists;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    populatePassenger(passenger, flightNumber, sendNotification) {
      return {
        _id: passenger._id ? passenger._id : null,
        reference: uuidv4(),
        firstName: passenger.first_name,
        lastName: passenger.last_name,
        fullName: passenger.full_name,
        email: passenger.email,
        phone: passenger.phone,
        gender: passenger.gender,
        type: passenger.type,
        primary: false,
        notify: sendNotification,
        flightNumber: flightNumber
      };
    },
    getRegisterStatus(passenger, passengerId) {
      if (passengerId) {
        return false;
      } else {
        return passenger.email || passenger.phone;
      }
    },
    selectPassenger(passengerId) {
      let passenger = this.passengers.find(
        passenger => passenger._id === passengerId
      );
      if (passenger) {
        this.passenger.first_name = passenger.first_name;
        this.passenger.last_name = passenger.last_name;
        this.passenger.full_name = passenger.full_name;
        this.passenger.email = passenger.email;
        this.passenger.phone = passenger.phone;
        this.passenger.gender = passenger.gender;
        this.passenger.address = {
          country: "",
          city: "",
          state: "",
          zip_code: "",
          street: ""
        };
        this.passenger.notes = "";
        this.passenger.relationship = {
          owner: this.partner.id,
          type: this.partner.type
        };
        this.passenger.another_contact = {
          identifier: "",
          type: ""
        };
        this.passenger.type = "ADULT";
        this.contactNumber = this.passenger.phone;
        this.sendNotification = false;
        this.$v.passenger.phone.$model = passenger.phone;
        this.$v.passenger.email.$model = this.passenger.email;
      }
    },
    clearData() {
      this.passenger = lodash.cloneDeep({
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        phone: "",
        gender: "male",
        address: {
          country: "",
          city: "",
          state: "",
          zip_code: "",
          street: ""
        },
        notes: "",
        relationship: {
          owner: "",
          type: "travel_agency"
        },
        another_contact: {
          identifier: "",
          type: ""
        },
        type: "ADULT"
      });
      this.contactNumber = "";
      this.flightNumber = "";
      this.sendNotification = false;
      this.passengerId = null;
      this.$v.passenger.$reset();
      this.$v.passenger.email.$model = "";
      this.$v.passenger.phone.$model = "";
    },
    closeModal() {
      this.showNewPassengerModal = false;
      this.$emit("close", false);
    },
    setSendNotification(value) {
      if (this.$v.passenger.email.$model === "") {
        this.$v.passenger.email.$reset();
      }
    },
    isIncluded(passenger, passengersIncluded = []) {
      return passengersIncluded
        .filter(item => item.email || item.phone)
        .find(
          item =>
            (item.email === passenger.email && passenger.email !== "") ||
            (item.phone === passenger.phone && passenger.phone !== "")
        )
        ? true
        : false;
    },
    getLabelTransferType(transferType) {
      if (["arrival", "departure"].includes(transferType)) {
        return "Flight N°";
      } else if (transferType === "station") {
        return "Rail Line";
      } else if (transferType === "port") {
        return "Cruise Ship";
      } else {
        return "";
      }
    },
    getEmailValidationErrorMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Enter a valid email";
        } else if (!email.email) {
          return "Email is invalid";
        } else if (!email.customValidator) {
          return "Email is already used.";
        }
      } else {
        return "";
      }
    },
    getPhoneNumberValidationErrorMessage(phone) {
      if (phone.$error) {
        if (!phone.minLength || !phone.maxLength) {
          return `Entenr a valid Contact Number.`;
        }

        if (!phone.customValidator) {
          return "Contact Number is already in use by another PAX.";
        }
      }
      return "";
    }
  },
  computed: {
    ...mapGetters(["sesion"]),
    totalPassengers: function() {
      return this.passengersIncluded.length;
    }
  },
  validations: {
    passenger: {
      first_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      last_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      email: {
        required: requiredIf(function(value) {
          return this.sendNotification;
        }),
        customValidator: async function(value) {
          if (this.passengerId) {
            return true;
          } else {
            if (value) {
              return this.validateEmail(value)
                ? await this.verifyPassengerEmail(value, this.partner.id)
                : false;
            } else {
              return true;
            }
          }
        }
      },
      phone: {
        minLength: minLength(9),
        maxLength: maxLength(17),
        customValidator: async function(value) {
          if (this.passengerId) {
            return true;
          } else {
            if (value) {
              return value.length >= 9 && value.length <= 17
                ? await this.verifyPassengerPhone(value, this.partner.id)
                : false;
            } else {
              return true;
            }
          }
        }
      }
    }
  }
};
</script>
